import { render, staticRenderFns } from "./FinancialReport.vue?vue&type=template&id=5da9c0aa&scoped=true"
import script from "./FinancialReport.vue?vue&type=script&lang=js"
export * from "./FinancialReport.vue?vue&type=script&lang=js"
import style0 from "./FinancialReport.vue?vue&type=style&index=0&id=5da9c0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9c0aa",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fviews%2Freports%2Ffinancial-report%2FFinancialReport.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports